import { Button } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import UserPassword from "../UserPassword/UserPassword";
import './ForgotPasswordSet.scss';

const ForgotPassword = () => {
  const [user] = useState({});
  const [username, setUsername] = useState("");
  const userPasswordRef = useRef(null);
  const [nextButtonDisabledState, setNextButtonDisabledState] = useState(false);
  const history = useHistory();
  const location = useLocation<{ username?: string } | undefined>();

  // The address arrives in router state (ForgotPassword) rather than the URL, which analytics would
  // otherwise report. The query string is still honoured for links that predate that change.
  // Without either there is nothing to confirm, so the reset starts again.
  const setUsernameValue = async () => {
    const email = location.state?.username ?? new URLSearchParams(location.search).get("username");
    if (!email) {
      history.push("/forgotPassword");
      return;
    }
    setUsername(email);
  }

  useEffect(() => {
    setUsernameValue();
    // eslint-disable-next-line
  }, []);

  const handleNext = async () => {
    if (userPasswordRef && userPasswordRef.current) {
      const current = userPasswordRef?.current as any;
      var res = await current.next();
      if (res) {
        history.push("/login");
      }
    }
  };

  return (
    <div className="ForgotPassword">
      <div className="ft-22">
        <UserPassword user={user} setNextButtonDisabledState={setNextButtonDisabledState} ref={userPasswordRef} confirmPasswordUsername={username} />
        <Button
          disabled={nextButtonDisabledState}
          className="save-button"
          variant="contained"
          color="primary"
          onClick={() => handleNext()}
        >
          Save Password
        </Button>
      </div>
    </div>
  );
}

export default ForgotPassword;

